import { addDays, format } from "date-fns";
import { parseUtcTimestamp } from "./utcDateTime";
import { parseCalendarDate, formatInstant, validTimeZone } from "./dateTime";
const EXPLICIT_TIME_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;
/** Leave's proven legacy UTC timestamp contract; never use for literal full-day dates. */
export const normalizeLeaveUtcValue = (value: string): string => {
  const trimmed = value.trim();
  return EXPLICIT_TIME_ZONE.test(trimmed) ? trimmed : `${trimmed}Z`;
};
export const leaveUtcDate = (value?: string | null): Date | null => parseUtcTimestamp(value);
/** A Date contains an instant; browser-local display occurs only at formatting. */
export const leaveLocalDate = leaveUtcDate;
/** Literal full-day dates are native picker Dates with the same local year/month/day. */
export const leaveDateOnlyDate = (value?: string | null): Date | null => value ? parseCalendarDate(value.slice(0, 10), true) : null;
export const leaveAllDayCalendarRange = (start?: string | null, inclusiveEnd?: string | null): { start: Date; end: Date } | null => {
  const begin = leaveDateOnlyDate(start), end = leaveDateOnlyDate(inclusiveEnd);
  return begin && end ? { start: begin, end: addDays(end, 1) } : null;
};
export const formatLeaveLocalTime = (value?: string | null, fallback = "--"): string => {
  const date = leaveLocalDate(value); return date ? format(date, "h:mm a") : fallback;
};
export const formatLeavePartialDayInZone = (value: string | null | undefined, timeZone: string): { date: string; time: string } | null => {
  const instant = leaveUtcDate(value), zone = timeZone === "Central Standard Time" ? "America/Chicago" : timeZone;
  if (!instant || !validTimeZone(zone)) return null;
  return { date: formatInstant(instant, "MMM dd, yyyy", zone), time: formatInstant(instant, "h:mm a", zone) };
};
export const formatLeaveLocalTimeRange = (start?: string | null, end?: string | null, fallback = "--"): string => {
  const begin = leaveLocalDate(start), finish = leaveLocalDate(end);
  return begin && finish ? `${format(begin, "h:mm a")} – ${format(finish, "h:mm a")}` : fallback;
};

export const getLeaveTypeEmoji = (leaveType?: string | null): string => {
  const normalized = leaveType?.trim().toLowerCase() || "";
  if (normalized.includes("vacation")) return "🏖️";
  if (normalized.includes("sick")) return "🤒";
  return "";
};

export const formatLeaveTypeLabel = (leaveType?: string | null): string => {
  const name = leaveType?.trim() || "Time Off";
  const emoji = getLeaveTypeEmoji(name);
  return emoji ? `${emoji} ${name}` : name;
};
